import { BaseRepository } from "@/repositories/base-repository.ts"
import type { IRentalIntakeMaterialization } from "@/interfaces/api/rental-intake-materialization.interface.ts"

export class RentalIntakeMaterializationRepository extends BaseRepository<IRentalIntakeMaterialization> {
  resourcePath = "administration/rental-intake-materializations"
}
